import React, {Component} from 'react';

import '../../styles/elements/imageText.css';
import SvgImageLoader from './SvgImageLoader';

class ImageText extends Component {
    render() {
        return (
            <div className={'image-text' + (this.props.className ? ' ' + this.props.className : '')}>
                <div className="image-text__text">
                    <div className="image-text__text-conntainer">
                        {this.props.title ? (<h2 className="image-text__title">{ this.props.title }</h2>) : ''}
                        <div className="image-text__content">
                            {this.props.content}
                        </div>
                    </div>
                </div>
                <div className="image-text__image-container">
                  <SvgImageLoader
                    svg={this.props.svg}
                    preview={this.props.thumbnail}
                    image={this.props.image}
                    class="image-text__image"
                    alt={this.props.title}
                  />
                </div>
            </div>
        )
    }


}

export default ImageText;



// WEBPACK FOOTER //
// ./src/js/elements/ImageText.js